import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { AcercadeComponent } from 'src/app/components/shared/components/acercade/acercade.component';
import { UsersConectedComponent } from 'src/app/components/shared/components/users-conected/users-conected.component';
import { IUnit } from 'src/app/modules/unit/interfaces/unit.interface';
import {
  INotification,
  NotificacionService,
} from 'src/app/services/notificaciones.service';
import { SocketService } from '../../services/socket.service';
import { UnitsService } from '../../services/units.service';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'main-layout-ras',
  templateUrl: './main-layout-ras.component.html',
  styleUrls: ['./main-layout-ras.component.scss'],
})
export class MainLayoutRasComponent implements OnInit {
  view: boolean = false;
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
  notifications: INotification[] = [];
  notificaciones: INotification[] = [];

  title: string;


  viewNotifications = false;

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private userService: UserService,
    private _notification: NotificacionService,
    private readonly socketService: SocketService,
    private _snackBar: MatSnackBar,
    private unitsService: UnitsService
  ) {
    let body = document.getElementsByTagName('BODY')[0];
    body.classList.add('mini-sidebar');

    _notification.updateUnreads.subscribe({
      next: () => {
        this.getNotifications();
      },
    });
    //this.trigger.openMenu()

    
  }

  get name() {
    return this.userService.currentUser?.fullname;
  }
  get roeleName() {
    return this.userService.currentUser?.role.name;
  }
  get photo() {
    return this.userService.currentUser.photo || undefined; //'assets/images/user.png';
  }
  ngOnInit(): void {
    this.socketService.socket.on('new_notification', () => {
      this.getNotifications();
    });

    this.getNotifications();
  }

  countNotifications = 0;

  doLogout() {
    this.userService.doLogout();
  }

  getNotifications() {
    this._notification.countNotificationsUnread().subscribe((count) => {
      this.countNotifications = count;
    });
  }

  getUnits() {
    this.unitsService.getAll().subscribe({
      next: (res: IUnit[]) => {
        this.units = res;
      },
    });
  }

  ngAfterViewInit(): void {}

  units!: IUnit[];

  get unistAvailable() {
    return this.userService.currentUser?.role.units;
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  get permissions() {
    return this.userService.currentUser.role;
  }

  get userUnits() {
    let role = this.userService.currentUser?.role;
    return role.units.map((unit) => {
      return {
        link: `/rasCases/${unit._id}`,
        name: unit.routeName || unit.name,
        exact: true,
        click: null,
        if: true,
      };
    });
  }

  get seeUsers() {
    const { createUsers, editUsers, deleteUsers } = this.permissions;
    return createUsers || editUsers || deleteUsers;
  }

  get seeRoles() {
    const { editRoles, createRoles, deleteRoles } = this.permissions;
    return editRoles || createRoles || deleteRoles;
  }

  get seeUnits() {
    const {
      createCaseType,
      editCaseType,
      deleteCaseType,
      editTask,
      createTask,
      deleteTask,
    } = this.permissions;

    return (
      createCaseType ||
      editCaseType ||
      deleteCaseType ||
      editTask ||
      createTask ||
      deleteTask
    );
  }

  nav = [
    {
      link: null,
      name: '',
      icon: 'bar',
      exact: true,
      click: null,
      if: true,
    },
    {
      link: null,
      name: 'Módulo de investigación',
      icon: 'book',
      exact: false,
      if: true,
      subNav: [
        ...this.userUnits,
        ...[
          {
            link: '/resumeRas',
            name: 'Resumen RAS',
            icon: 'home',
            exact: true,
            subNav: null,
            click: null,
            if: true,
            view: false,
          },
        ],
      ],
    },

    {
      link: null,
      name: 'Administración',
      icon: 'users-cog',
      if: true,
      exact: false,
      subNav: [
        {
          link: '/userView',
          name: 'Gestión de usuarios',
          exact: true,
          click: null,
          if: this.seeUsers,
        },
        {
          link: '/rolesView',
          name: 'Gestión de roles y permisos',
          exact: true,
          click: null,
          if: this.seeRoles,
        },
        {
          link: '/gestion-apis',
          name: 'Gestión de APIS',
          exact: true,
          click: null,
          if: true,
        },
        {
          link: '/dashboard/seguridad-y-auditoria/auditoria',
          name: 'Log control del sistema',
          exact: true,
          click: null,
          if: false,
        },
        // {
        //   link: '/gruposView',
        //   name: 'Grupos',
        //   exact: true,
        //   click: null,
        //   if: true,
        // },
        {
          link: '/unitsView',
          name: 'Unidades',
          exact: true,
          click: null,
          if: this.seeUnits,
        },
      ],
      view: false,

      click: null,
    },
    {
      link: '/dashboard/ras-search-text',
      name: 'Buscador de Texto',
      icon: 'search',
      exact: true,
      click: null,
      if: true,
    },
    {
      link: null,
      name: 'Acerca De',
      icon: 'poll',
      exact: true,
      subNav: null,
      click: 'openAcercaDe',
      if: true,
      view: false,
    },
  ];

  openAcercaDe() {
    this.dialog.open(AcercadeComponent);
  }
  // conectedUsers() {
  //   this.dialog.open(UsersConectedComponent);
  // }
  clickNav(option: any) {
    if (option.view !== null || option.view !== undefined)
      option.view = !option.view;

    if (option.link) {
      this.router.navigate([option.link]);
      this.view = false;
    } else if (option.click) {
      this.view = false;
      this[option.click]();
    }
  }
}
